export const NOT_ASSIGNED_TITLE = "Not assigned to you";

export const ASSIGNED_TO_TIP =
  "Who this candidate is assigned to.\n\nAdmins and team members with full candidate access can assign, change or remove the assignment.\n\nOther team members can only open, change status and assign stages for candidates assigned to them.";

export const RESTRICTED_TIP =
  "You can open, change status and assign stages only for candidates assigned to you. Unassigned candidates and candidates assigned to others are greyed out and read-only.";

export const CANDIDATE_VIEWS = {
  CANDIDATE: "candidate",
  ACTIVITY: "activity",
};

export const initialsOf = (name) => {
  const parts = String(name || "?").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Fixed-position coordinates for a portal dropdown anchored below `btnEl`, clamped to the viewport.
export const calcPos = (btnEl, gap, minWidth) => {
  const rect = btnEl.getBoundingClientRect();
  const left = Math.max(8, Math.min(rect.left, window.innerWidth - minWidth - 8));
  return { top: rect.bottom + gap, left };
};

// Like calcPos, but right-aligned to the button and flips upward when there's no room below.
export const calcMenuPos = (btnEl, { width, height, alignRight = false }) => {
  const rect = btnEl.getBoundingClientRect();
  const openUp = window.innerHeight - rect.bottom < height && rect.top > height;
  const anchor = alignRight ? rect.right - width : rect.left;
  return {
    left: Math.max(8, Math.min(anchor, window.innerWidth - width - 8)),
    ...(openUp ? { bottom: window.innerHeight - rect.top + 4 } : { top: rect.bottom + 4 }),
  };
};

export const openCandidateProfile = (jobId, candidateId) =>
  window.open(`/jobs/${jobId}/candidates/${candidateId}?tab=all`, "_blank");
